import { Component, OnChanges, inject, ChangeDetectionStrategy, input } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {UnitConversionUtils} from '../../unit-conversion-utils';
import {UnitRatingResponse} from '../../../model/unit-rating-response';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { PerformanceResultsComponent } from '../performance-results/performance-results.component';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-direct-drive-performance-results',
    templateUrl: './direct-drive-performance-results.component.html',
    styleUrls: ['./direct-drive-performance-results.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, PerformanceResultsComponent]
})
export class DirectDrivePerformanceResultsComponent implements OnChanges {
  private userStateService = inject(UserStateService);
  readonly ratingResponse = input.required<UnitRatingResponse>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly isSureflow = input<boolean>(undefined!);
  airflow = 0;
  standardAirflow = 0;
  outputPower = 0;
  controlVoltage = 0;
  totalStaticPressure = 0;
  fullLoadAmps = 0;
  horsepower = 0;
  isExpanded = true;
  isMetric = false;
  private sectionKey = ConfigurationSection.PERFORMANCE_RESULTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.clearOutputValues();
    const metricInput = SelectionUtils.getEntity(this.selectionEntities(), 'USMetricInput');
    this.isMetric = metricInput && 'true' === metricInput.Value;
    if (this.ratingResponse()) {
      this.airflow = this.ratingResponse().Airflow;
      this.standardAirflow = this.ratingResponse().StandardAirflow ?? 0;
      if (this.ratingResponse().CircuitResponse) {
        this.outputPower = this.ratingResponse().CircuitResponse.OutputPower;
        this.fullLoadAmps = this.ratingResponse().CircuitResponse.FullLoadAmps;
        this.controlVoltage = this.ratingResponse().CircuitResponse.ControlVoltage;
        this.totalStaticPressure = this.ratingResponse().CircuitResponse.TotalStaticPressure;
        this.horsepower = this.ratingResponse().CircuitResponse.HorsepowerValue;
      }
    }
  }

  private clearOutputValues(): void {
    this.airflow = 0;
    this.standardAirflow = 0;
    this.outputPower = 0;
    this.fullLoadAmps = 0;
    this.controlVoltage = 0;
    this.totalStaticPressure = 0;
    this.horsepower = 0;
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  getAirflowMeasurementUnits(isStandard: boolean): string {
    return UnitConversionUtils.getAirflowUnits(this.isMetric, isStandard);
  }

  getPressureMeasurementUnits(): string {
    return UnitConversionUtils.getEspUnits(this.isMetric);
  }

}
